<div class="panel-wrapper h-full w-full">
  <div
    class="flex justify-center items-center h-full w-full"
  >
    <app-image
      [loaderTheme]="{
             'height': '100%',
             'width': '100%'
            }"
      [url]="'/assets/images/png/stanford-medical-logo.png'"
      class="image-container"
    ></app-image>
  </div>
</div>
